<div class="banner" role="banner">
  <h1>{{ 'badges.page.title' | translate }}</h1>
</div>

<fgb-scorecard-nav></fgb-scorecard-nav>

<div class="container mt-4">
  <fgbcl-badge-overview-list [showPlaceholder]="true"></fgbcl-badge-overview-list>
</div>
